import React, { useEffect, useState } from 'react'
import { Icon } from '@/icons'
import { motion, AnimatePresence } from 'framer-motion'
import * as styles from './Toast.css'

interface ToastProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top-center' | 'bottom-center'
  className?: string
  status: 'success' | 'error' | 'info'
  message: string
  isVisible?: boolean
  autoHide?: boolean
  duration?: number
}

export default function Toast({ 
  position = 'top-center', 
  className = '', 
  status, 
  message, 
  isVisible = true,
  autoHide = true,
  duration = 2000
}: ToastProps) {
  const [visible, setVisible] = useState(isVisible)

  useEffect(() => {
    setVisible(isVisible)
  }, [isVisible])

  useEffect(() => {
    if (visible && autoHide) {
      const timer = setTimeout(() => {
        setVisible(false)
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [visible, autoHide, duration])
  const getPositionClass = () => {
    switch (position) {
      case 'top-left':
        return styles.toastPosition.topLeft
      case 'top-right':
        return styles.toastPosition.topRight
      case 'bottom-left':
        return styles.toastPosition.bottomLeft
      case 'bottom-right':
        return styles.toastPosition.bottomRight
      case 'top-center':
        return styles.toastPosition.topCenter
      case 'bottom-center':
        return styles.toastPosition.bottomCenter
      default:
        return styles.toastPosition.topRight
    }
  }

  const getStatusClass = () => {
    switch (status) {
      case 'success':
        return styles.toastStatus.success
      case 'error':
        return styles.toastStatus.error
      case 'info':
        return styles.toastStatus.info
      default:
        return styles.toastStatus.info
    }
  }

  const getStatusIcon = () => {
    switch (status) {
      case 'success':
        return <Icon name="check" size={16} className="*:fill-green-600" />
      case 'error':
        return <Icon name="close" size={16} className="*:fill-red-600" />
      case 'info':
        return <Icon name="circle" size={16} className="*:fill-blue-600" />
      default:
        return <Icon name="circle" size={16} className="*:fill-gray-600" />
    }
  }

  return (
    <AnimatePresence>
      {visible && (
        <div className={`fixed ${styles.toastWrapper} ${getPositionClass()}`}>
            <motion.div 
            className={`${styles.toast} ${getStatusClass()} ${className}`}
            initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    duration: 0.4,
                    scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                }}
            >
            <div className={styles.toastContent}>
                {getStatusIcon()}
                <span>{message}</span>
            </div>
            </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}